module.exports = __webpack_public_path__ + "img/shop.79128810.svg";